<!-- Public Layout - For unauthenticated users -->
<div class="public-layout-container">
  
  <!-- Public Navigation -->
  <app-nav-menu></app-nav-menu>
  
  <!-- Main Content Area -->
  <main class="main-content" [class.with-background]="shouldShowBackground()">
    <div class="content-wrapper">
      <!-- Child routes will render here (home, login, register, etc.) -->
      <router-outlet></router-outlet>
      <app-bootstrap-modal></app-bootstrap-modal>
    </div>
  </main>
  
  <!-- Footer -->
  <app-footer></app-footer>
  
</div>
